import styled from 'styled-components'
//styled components
const Wrapper = styled.div`
    width: ${props => props.width ? props.width + 'px' : '400px'};
    margin-bottom: 30px;
`;

const LabelSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
const Label = styled.div`
    font-size: 14px;
    color: #414670;
    opacity: 0.8;
`;
const Error = styled.div`
    font-size: 12px;
    color: #ff4141;
`;

const Input = styled.input`
    height: 41px;
    border: none;
    width: ${props => props.width ? props.width + 'px' : '400px'};
    font-size: 16px;
    color: #545876;
    padding: 0;
    font-family: Lato, Roboto, Arial, sans-serif;
    background: transparent;
    &:focus {
        outline: none;
    }
	&::-webkit-input-placeholder {
		color: #414670;
		opacity: 0.4;
	}
`

const InputWrapper = styled.div `
    width: 100%;
    border-radius: 17.5px;  
    border: solid 1.5px #f1f1f1;
    background-color: #f4f4f4;
    padding-left: 10px;
    margin-left: -10px;
    & .h-google-logo {
        & .h-google-logo-svg {
            margin-bottom: -5px;
            margin-right: 9px;
        }
    }
    &.h-input-filled {
        background: transparent;
    }
    & input {
        margin-top: -2px;
    }
    &:focus-within {
        background: transparent;
    }
`


export {
    Wrapper, Label, LabelSection, Error, Input, InputWrapper
}
